<template lang="html">
  <div>
    <input type="text" @change="set('name', $event)" placeholder="Nom">
    <input type="email" @change="set('email', $event)" placeholder="Email">
    <input type="phone" @change="set('phone', $event)" placeholder="Téléphone">
    <input type="text" @change="set('address', $event)" placeholder="Adresse">
    <input type="text" @change="set('city', $event)" placeholder="Ville">
    <input type="text" @change="set('zip', $event)" placeholder="Code Postal">
    <div v-if="hasMoreQuestions" class="hasMoreQuestions">
      Si vous avez plus de questions, merci de nous contacter au <a href="tel:0146316380">01 46 31 63 80</a> ou par mail via <a href="mailto:contact@plantravail.fr">contact@plantravail.fr</a>.
    </div>
    <textarea @change="set('questions', $event)" @keydown="limit($event)" placeholder="Vos questions"></textarea>
  </div>
</template>

<script>
export default {
  data () {
    return {
      hasMoreQuestions: false
    }
  },
  methods: {
    set (id, e) {
      this.$store.commit('setUserInfos', {id, value: e.target.value})
    },
    limit (e) {
      if (e.keyCode === 8) {
        if ((e.target.value).length < 200) {
          this.hasMoreQuestions = false
        }
        return
      }
      if ((e.target.value).length >= 200) {
        this.hasMoreQuestions = true
      }
      if ((e.target.value).length >= 250) {
        e.preventDefault()
        e.stopPropagation()
      }
      if ((e.target.value).length < 200) {
        this.hasMoreQuestions = false
      }
    }
  }
}
</script>

<style lang="css" scoped>
input {
  border: 1px solid #ebebeb;
}
.hasMoreQuestions {
  background: #1e4f92;
  color: #FFF;
  padding: 10px;
  margin: 10px 0;
}
.hasMoreQuestions a {
  color: #FFF;
}
</style>



// WEBPACK FOOTER //
// Coordonnees.vue?11dc82d0